import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../../models/Constants';
import { InteractionHistoryService } from 'src/app/services/interaction-history.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-open-message',
  templateUrl: './open-message.component.html',
  styleUrls: ['./open-message.component.scss']
})
export class OpenMessageComponent implements OnInit {
  appURL = '';
  iconConfig: any;
  constructor(public rootScope: RootScopeService, private apiService: ApiService, public intHistService: InteractionHistoryService, @Inject(MAT_DIALOG_DATA) public messageData: any) {

    this.openMessageDetail();
  }

  ngOnInit(): void {
    this.iconConfig = {
      iconName: 'xmark',
      iconType: 'light'
    }

  }


  messageAPIData!: SafeUrl;
  isAPIError: boolean = false;
  showLoader: boolean = false;
  loaderType = Constants.LOADER_TYPE.CARD;
  /**
   * @author Amarjeet
   * @description Added for CCR1-4130 . openMessageDetail() method API call for message details data.
   */
  openMessageDetail() {
    this.showLoader = true;
    let paramsObject : any = {
      clientId: this.rootScope.activeCustTab.clientId,
      documentId: this.messageData?._id,
      platformInternalId: this.messageData?.messageDetails?.platformInternalId ? this.messageData.messageDetails.platformInternalId : ''
      //systemInstanceId: this.messageData?.messageDetails?.systemInstanceId ? this.messageData.messageDetails.systemInstanceId : ''
    };

    if(this.messageData?.messageDetails?.systemInstanceId){
      paramsObject.systemInstanceId = this.messageData.messageDetails.systemInstanceId;
    }
    /* istanbul ignore next */
    this.apiService.getIHMessageData(paramsObject).subscribe({
      next: (arrayBuffer: ArrayBuffer) => {
        let binary = '';
        let bytes = new Uint8Array(arrayBuffer);
        let len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }

        let temp = document.createElement('div');
        temp.innerHTML = binary;
        Array.from(temp.querySelectorAll(
          'img'
        )).forEach((eles) => {

          if (eles.src.includes(window.location.href))
            eles.src = eles.src.replace(window.location.href, 'data:image/jpg;base64,/'); + eles.src;
          // console.log(eles.src);

        })
        /* Bug- CCR1-6953*/
        Array.from(temp.querySelectorAll('a')).forEach((eles) => {      
          eles.removeAttribute("href");
          eles.removeAttribute("target");
          eles.removeAttribute("rel");
        })

        this.messageAPIData = temp.innerHTML;
        this.isAPIError = false;
        this.showLoader = false;

      },
      error: (error) => {
        console.error('Error occurred:', error);
        this.isAPIError = true;
        this.showLoader = false;
      }
    });
  }



  /**
   * @author Amarjeet
   * @description Added for CCR1-4130. This method convert given date in MMM-DD-YYYY format.
   * @param date 
   * @returns 
   */
  getDate(date: any) {
    if (date) {
      const formattedDate: any = this.rootScope.getDate(date);
      return formattedDate === 'Invalid date' ? date : formattedDate;
    } else {
      return Constants.DATE_NOT_FOUND;
    }
  }



}
